import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag: (command: string, targetId: string, config?: object) => void;
  }
}

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("config", "G-VVY3BY6CR5", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
};
